import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../../constants/view-texts';
import { MuiInput } from '../../shared/form-element';
import { CreateDialogViewTemplate } from '../create-dialog-template/create-dialog-view-template';

const vt = viewTexts.dialogs.createNewKoumuten;

const InputWrapper = styled.div`
  padding: 5px;
`;

interface Props {
  open: boolean;
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  registererName: string;
  koumutenName: string | undefined;
  koumutenNameErrors: string[] | undefined;
  koumutenNameOnInput: (v: string) => void;
  submitButtonEnabled: boolean;
  nonFieldErrors: string[];
}

export const CreateNewKoumutenDialogView: FC<Props> = memo(
  ({
    open,
    onClose,
    registererName,
    koumutenName = '',
    koumutenNameErrors = [],
    koumutenNameOnInput,
    submitButtonEnabled,
    nonFieldErrors
  }: Readonly<Props>) => (
    <CreateDialogViewTemplate
      open={open}
      onClose={onClose}
      title={vt.title}
      descriptions={vt.descriptions}
      submitButtonEnabled={submitButtonEnabled}
      nonFieldErrors={nonFieldErrors}
    >
      <InputWrapper>
        <MuiInput
          label={vt.labels.registerer}
          required={true}
          value={registererName}
          disabled={true}
        />
      </InputWrapper>
      <InputWrapper>
        <MuiInput
          label={vt.labels.koumutenName}
          required={true}
          value={koumutenName}
          onInput={koumutenNameOnInput}
          helperText={koumutenNameErrors.join(' ')}
          error={koumutenNameErrors.length > 0}
        />
      </InputWrapper>
    </CreateDialogViewTemplate>
  )
);

CreateNewKoumutenDialogView.displayName = 'CreateNewKoumutenDialogView';
